import React from "react";
import {AppointmentCounterText} from "../components/my-page/AppointmentCounterText";
import {Box, List} from "@mui/material";
import {AlfyButton} from "../components/AlfyButton";
import {useNavigate} from "react-router-dom";
import {UserAppointment} from "../models/UserAppointment";
import {AppointmentListItem} from "../components/my-page/AppointmentListItem";

interface CreatedAppointmentsPageProps {
    appointments: UserAppointment[]
}

export const CreatedAppointmentsPage: React.FC<CreatedAppointmentsPageProps> = ({ appointments }) => {
    return (
        <>
            <AppointmentCounterText appointmentCount={appointments.length} />
            {appointments.length === 0 ? <EmptyCreatedAppointmentBody /> : <CreatedAppointmentBody appointments={appointments} />}
        </>
    )
}

const EmptyCreatedAppointmentBody: React.FC = () => {
    const navigate = useNavigate();

    const handleClick = (path: string) => {
        navigate(path);
    }

    return (
        <Box alignItems={'center'} height={'100%'}>
            <Box sx={{textAlign: 'center', color: '#9E9E9E'}}>
                <span style={{fontSize: '18px', fontWeight: 500}}>아직 만든 약속이 없어요</span>
                <Box height={"12px"} />
                <span style={{fontSize: '15px', fontWeight: 500}}>약속 링크를 만들고<br/>친구들과 손쉽게 날짜를 정해보세요</span>
                <Box height={"28px"} />
                <AlfyButton text={"약속 만들기"} onClick={() => {handleClick("/appointments/create")}} />
            </Box>
        </Box>
    )
}

interface CreatedAppointmentBodyProps {
    appointments: UserAppointment[],
}

const CreatedAppointmentBody: React.FC<CreatedAppointmentBodyProps> = ({ appointments }) => {
    return (
        <List>
            {appointments.map(appointment => <AppointmentListItem appointment={appointment} key={appointment.id} />)}
        </List>
    )
}